<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="800">
      <v-card>
        <v-card-title class="text-h5">
          Edit Data Vessel - {{ kv }}
        </v-card-title>

        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="3" class="py-1">
              <label for="kv">KV</label>
              <input
                type="text"
                id="kv"
                v-model="formData.kv"
                @blur="updateVessel"
                disabled
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" class="py-1">
              <label for="nama_kapal">Nama Kapal</label>
              <input
                type="text"
                id="nama_kapal"
                v-model="formData.nama_kapal"
                @blur="updateVessel"
                @keydown.enter="focusRefs('tgl_berangkat')"
                ref="nama_kapal"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" class="py-1">
              <label for="tgl_berangkat">Tanggal Berangkat</label>
              <input
                type="date"
                id="tgl_berangkat"
                v-model="formData.tgl_berangkat"
                @blur="updateVessel"
                @keydown.enter="focusRefs('voy1')"
                ref="tgl_berangkat"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" class="py-1">
              <label for="voy1">Voy</label>
              <div class="flex">
                <input
                  type="text"
                  id="voy1"
                  v-model="formData.voy1"
                  @blur="updateVessel"
                  @keydown.enter="focusRefs('voy2')"
                  ref="voy1"
                />
                <p class="my-auto separator">/</p>
                <input
                  type="text"
                  id="voy2"
                  v-model="formData.voy2"
                  @blur="updateVessel"
                  @keydown.enter="createVessel"
                  ref="voy2"
                />
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-data-table
                :headers="containerHeaders"
                :items="containers"
                :loading="loading"
                :items-per-page="5"
                :sort-by="['demurage']"
                :sort-desc="[true]"
                class="elevation-1 mt-2"
                dense
              >
                <template v-slot:item.kv="{ item }">
                  <v-text-field
                    dense
                    hide-details
                    class="pa-0 ma-0"
                    @keydown.enter="updateKV($event, item.id)"
                  ></v-text-field>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            tabindex="-1"
            @click="$emit('close-modal')"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "EditDataVessel",
  props: ["openModal", "kv", "data"],
  data() {
    return {
      loading: false,
      formData: {
        kv: "",
        nama_kapal: "",
        tgl_berangkat: "",
        voy1: "",
        voy2: "",
      },
      containerHeaders: [
        { text: "KV", value: "kv" },
        { text: "NoCont", value: "no_container" },
        { text: "Seal", value: "no_seal" },
        { text: "KC", value: "kc" },
        { text: "TglStuffing", value: "tgl_stuffing" },
        { text: "Demurage", value: "demurage" },
        { text: "Cargo", value: "cargo" },
        { text: "JenisCont", value: "jenis_container" },
        { text: "PrioritasBerangkat", value: "prioritas_berangkat" },
      ],
      containers: [],
    };
  },
  watch: {
    openModal(val) {
      if (val) {
        this.getBL();
        this.fetchContainer();
      }
    },
    data(val) {
      if (val.kv) {
        this.formData.kv = val.kv;
      }

      if (val.nama_kapal) {
        this.formData.nama_kapal = val.nama_kapal;
      }

      if (val.tgl_berangkat) {
        this.formData.tgl_berangkat = val.tgl_berangkat;
      }

      if (val.voy) {
        let voy = val.voy.split("/");

        this.formData.voy1 = voy[0];
        this.formData.voy2 = voy[1];
      }
    },
  },
  methods: {
    async getBL() {
      this.loading = true;

      await axios
        .get(`data-bl/${this.kv}`)
        .then((res) => {
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    async updateVessel() {
      if (!this.formData.kv) return;

      await axios
        .put(`vessel/${this.formData.kv}`, this.formData)
        .then((res) => {})
        .catch((err) => {
          alert(err.response.data.message);
        });
    },
    async updateKV(event, id) {
      await axios
        .put(`update-container/add-kv?id=${id}&kv=${event.target.value}`)
        .then((res) => {
          this.fetchContainer();
        })
        .catch((err) => {
          alert(err.response.data.message);
        });
    },
    async fetchContainer() {
      this.loading = true;

      await axios
        .get(`container-belum-berangkat`)
        .then((res) => {
          this.containers = res.data;

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    focusRefs(id) {
      this.$refs[id].focus();
    },
  },
};
</script>

<style scoped>
input {
  width: 100%;
  border: 1px solid lightgray;
  padding: 0 5px;
}

.flex {
  display: flex;
}

.separator {
  padding: 0 5px;
}
</style>